import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../../../hooks/useSetState';
import DatePicker from '../../../../components/FormElements/DatePicker/DatePicker';
import { validator, formatter } from '../../../../utils';
import { Link, useHistory } from 'react-router-dom';
import { createGiftChairRequest } from '../../../../redux/giftChairs/actions';
import jmoment from 'moment-jalaali';

const AddGiftChairs = props => {
  let dispatch = useDispatch();
  let history = useHistory();

  const [controls, setControls] = useSetState({
    mobileNumber: '',
    validFrom: '',
    validTo: '',
    giftChairs: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const { searchedSpecialUsersList } = useSelector(state => ({
    searchedSpecialUsersList: state.discountCodesReducer.searchedSpecialUsersList
  }));

  const onChangeGiftChaires = (e) => {
    e.preventDefault();
    let { value } = e.target;

    if (
      !value ||
      (validator.isNumber(value.replaceAll(',', '')) &&
        value.replaceAll(',', '') < 1000000)
    ) {
      const val = new Intl.NumberFormat().format(value.replaceAll(',', ''));
      onChangeValue('giftChairs', val)
    }
  };

  const onSubmit = e => {
    e.preventDefault();

    let standardChairs = Number(formatter.toStandard(
      controls.giftChairs.replaceAll(',', '')));

    let standardFromDate = formatter.toStandard(
      jmoment(controls.validFrom).format('jYYYY/jMM/jDD'),
    );

    let standardToDate = formatter.toStandard(
      jmoment(controls.validTo).format('jYYYY/jMM/jDD'),
    );

    let data = {
      mobileNumber: controls.mobileNumber,
      fromDate: standardFromDate,
      toDate: standardToDate,
      numberOfRsee: standardChairs,
    };

    dispatch(createGiftChairRequest(data))
      .then(() => {
        history.push('/packages/gift-chairs');
      })
      .catch(error => console.log('error', error));
  };

  return (
    <>
      <section className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-right text-muted py-4'>
          {locales('gift.chairs')}
        </h3>
        <div className='form-actions'>
          <button
            type='submit'
            form='giftChairs'
            className='btn btn-success px-2 mx-3'
          >
            <i className='fa fa-save' />
            {locales('labels.save')}
          </button>
          <Link to='/packages/gift-chairs' className='btn btn-default'>
            <i className='fa fa-reply' />
            {locales('label.cancel')}
          </Link>
        </div>
      </section>

      <section className='panel panel-default'>
        <div className='panel-heading'>
          <h3 className='panel-title'>
            <i className='fa fa-pencil' />
            {locales('gift.package')}
          </h3>
        </div>

        <div className='panel-body'>
          <form className='col form-horizontal' onSubmit={onSubmit} id='giftChairs'>
            <div className="form-row">
              <div className="col-lg-6 col-md-6 col-sm-12 my-2 required">
                <label className="rsee-form-label col-12 text-right" htmlFor="validFrom">
                  {locales('tables.creditFrom')}
                </label>
                <DatePicker
                  marge={true}
                  placeholder="تاریخ شروع"
                  id="fromDate"
                  onChange={val => onChangeValue('validFrom', val)}
                  name="fromDate"
                  value={controls.validFrom}
                  className={`form-control start col-12`}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 my-2 required">
                <label className="rsee-form-label col-12 text-right" htmlFor="validTo">
                  {locales('tables.till')}
                </label>
                <DatePicker
                  marge={true}
                  placeholder="تاریخ پایان"
                  id="toDate"
                  onChange={val => onChangeValue('validTo', val)}
                  name="toDate"
                  value={controls.validTo}
                  className={`form-control end col-12`}
                />
              </div>
            </div>

            <div className="form-row">
              <div className='col-sm-12 col-md-6 col-lg-6 my-2 required'>
                <label className="rsee-form-label text-right w-100">
                  {locales('tables.totalChairs')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      className='form-control full-width'
                      type='text'
                      name='giftChairs'
                      id={'giftChairs'}
                      value={controls.giftChairs}
                      onChange={e => onChangeGiftChaires(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 my-2 required">
                <label className="rsee-form-label text-right w-100">
                  {locales('enter.certain.user.phone.number')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      className='form-control full-width'
                      type='text'
                      name='mobileNumber'
                      id={'mobileNumber'}
                      value={controls.mobileNumber}
                      onChange={e => onChangeValue('mobileNumber', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </section>
    </>
  );
}

export default AddGiftChairs;